import moment from "moment/moment";

export const useDashboardEventList = (events = []) => {
    return events.map(item => ({
            ...item,
            startDate: moment(item.startDate),
            endDate: moment(item.startDate)
    }));
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/CustomHooks/useDashboardEventList.js